import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  AfterViewInit,
  ElementRef,
  ViewChild,
  NgZone,
  Inject,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { ResourcesMdlComponent } from "src/app/models/resources-mdl/resources-mdl.component";
// import Swiper from 'swiper';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

declare var Swiper: any;
declare var $: any;
declare var bootstrap: any; // Add this at the top with your other declarations
@Component({
  selector: "app-training-landing-page",
  templateUrl: "./training-landing-page.component.html",
  styleUrls: ["./training-landing-page.component.css"],
})
export class TrainingLandingPageComponent
  implements OnInit, OnDestroy, AfterViewInit, OnDestroy
{
  currentYear = new Date().getFullYear();
  isShow: boolean = true;

  private swiper?: any;
  private testimonialSwiper?: any;
  @ViewChild("rightContent") rightContentRef!: ElementRef;
  @ViewChild("swiperContainer") swiperContainerRef!: ElementRef;

  // @ViewChild('swiperContainerH') swiperContainerRef!: ElementRef;

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      const navbarCollapse = document.querySelector(".navbar-collapse");
      const navLinks = navbarCollapse?.querySelectorAll(".nav-link");

      navLinks?.forEach((link) => {
        link.addEventListener("click", () => {
          // Check if toggler is visible (mobile view)
          const toggler = document.querySelector(".navbar-toggler");
          if (toggler && window.getComputedStyle(toggler).display !== "none") {
            const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
            if (bsCollapse) {
              bsCollapse.hide();
            } else {
              // If no instance, create one and hide
              new bootstrap.Collapse(navbarCollapse, { toggle: false }).hide();
            }
          }
        });
      });
    });

    // 👉 Add this block at the end
    this.ngZone.runOutsideAngular(() => {
      const adjustPadding = () => {
        const header = document.querySelector(".top1") as HTMLElement;
        const content = document.getElementById("content");
        if (header && content) {
          content.style.paddingTop = header.offsetHeight + "px";
        }
      };

      // Run once after view is loaded
      adjustPadding();

      // Also re-run on window load & resize
      window.addEventListener("load", adjustPadding);
      window.addEventListener("resize", adjustPadding);
    });

    // Initialize Swiper after view is ready
    this.swiper = new Swiper(".category-style-two-carousel", {
      slidesPerView: 4,
      spaceBetween: 10,
      loop: true,
      centeredSlides: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 1000,
        disableOnInteraction: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
      },
    });

    this.testimonialSwiper = new Swiper(".testimonial-style-two-carousel", {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      speed: 2000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        576: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        992: { slidesPerView: 4 },
      },
      freeMode: true,

      allowTouchMove: true,
    });

    // courosul

    setTimeout(() => {
      this.isShow = true;
      // this.cdr.detectChanges(); // Ensure DOM updates

      setTimeout(() => {
        this.initSlick(); // Delay to ensure DOM is ready
      }, 0);
    }, 100);

    // const $slider = $('.slider');

    // // Setup slide counter
    // ($slider as any).on('init reInit afterChange', function (event: any, slick: any, currentSlide: number) {
    //   const i = (currentSlide ? currentSlide : 0) + 1;
    //   $('#slider-counter').text(('0' + i).slice(-2) + '/' + ('0' + slick.slideCount).slice(-2));
    // });

    // // Initialize slick
    // ($slider as any).slick({
    //   dots: false,
    //   arrows: true,
    //   infinite: true,
    //   speed: 500,
    //   slidesToShow: 1,
    //   adaptiveHeight: true,
    //   autoplay: false,
    //   autoplaySpeed: 3000,
    //   prevArrow: $('.slick-prev'),
    //   nextArrow: $('.slick-next')
    // });
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // const rightHeight = this.rightContentRef.nativeElement.offsetHeight;
        // const swiperEl = this.swiperContainerRef.nativeElement;

        // // Set swiper container height to match right content
        // swiperEl.style.height = `${rightHeight}px`;

        // Init Swiper
        this.swiper = new Swiper(".category-vertical-carousel", {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 0,
          loop: true,
          speed: 800,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      }, 0);
    });
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // const rightHeight = this.rightContentRef.nativeElement.offsetHeight;
        // const swiperEl = this.swiperContainerRef.nativeElement;

        // // Set swiper container height to match right content
        // swiperEl.style.height = `${rightHeight}px`;

        // Init Swiper
        this.swiper = new Swiper(".category-horizontal-carousel", {
          direction: "horizontal",
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          speed: 800,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        });
      }, 0);
    });
  }

  initSlick() {
    const $slider = $(".slider");

    $slider.on(
      "init reInit afterChange",
      function (event, slick, currentSlide) {
        const i =
          typeof currentSlide === "undefined"
            ? slick.currentSlide
            : currentSlide;
        $("#slider-counter").text(
          ("0" + (i + 1)).slice(-2) + "/" + ("0" + slick.slideCount).slice(-2),
        );
      },
    );

    $slider.slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      prevArrow:
        '<button class="slick-prev custom-arrow btn btn-outline-info me-2">‹</button>',
      nextArrow:
        '<button class="slick-next custom-arrow btn btn-outline-info">›</button>',
    });
  }

  constructor(
    private route: Router,
    private el: ElementRef,
    private ngZone: NgZone,
    private ngbMdl: NgbModal,
    @Inject(DOCUMENT) private document: Document,
  ) {
    // this.landingScripts()
  }

  ngOnInit(): void {}

  landingScripts() {
    $(document).ready(function () {
      $(".vertical-slider").slick({
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2500,
        speed: 1000,
        arrows: false,
        dots: false,
        infinite: true,
        cssEase: "linear",
      });
    });
  }

  ngOnDestroy(): void {
    // Cleanup if needed

    window.removeEventListener("load", () => {});
    window.removeEventListener("resize", () => {});
  }

  GoToLogin() {
    this.route.navigate(["/login"]);
  }

  GoToInstitution() {
    this.route.navigate(["/institution-reg"]);
  }

  openUploadModal() {
    const modalRef = this.ngbMdl.open(ResourcesMdlComponent, {
      scrollable: true,
      size: "xl",
      backdrop: "static",
      animation: true,
    });
    modalRef.componentInstance.title = "";
    modalRef.result.then(
      (res: any) => {},
      (r: any) => {
        console.log(r);
      },
    );
  }

  openUserGuide() {
    const pdfUrl = new URL(
      "assets/files/KEMIS_Institution_Registration_User_Guide.pdf",
      this.document.baseURI,
    ).href;

    const anchor = this.document.createElement("a");
    anchor.href = pdfUrl;
    anchor.target = "_blank";
    anchor.rel = "noopener";
    anchor.click();
  }
}
